import "../styles/LaunchPage.css";
import logo from "../assets/logo.png";

import {
  FaFacebookF,
  FaPhoneAlt
} from "react-icons/fa";

import { GiSmokingVolcano } from "react-icons/gi";

function LaunchPage() {

  const facebookLink =
    "https://www.facebook.com/MagmaMedia.Egy/?rdid=Nw3JNZzTCodiqpaw";

  return (
    <div className="launch-page">

      {/* BACKGROUND GLOWS */}
      <div className="glow glow-1"></div>
      <div className="glow glow-2"></div>
      <div className="glow glow-3"></div>

      {/* PARTICLES */}
      <div className="particles">
        {[...Array(15)].map((_, i) => (
          <span key={i}></span>
        ))}
      </div>

      {/* MAIN CONTENT */}
      <div className="hero-content">

        <div className="logo-wrap">
          <img src={logo} alt="Magma Media" />
        </div>

        <div className="agency-tag">
          Digital Marketing Agency
        </div>

        <h1 className="brand-title">
          <GiSmokingVolcano className="brand-volcano" />
          <span>MAGMA MEDIA</span>
        </h1>

        <h2>
          Where ideas fire up
        </h2>

        <p className="website-line">
        Our new website is on the way


          <br /><br />

        We're building a faster, stronger, and more creative
        digital experience for our clients

        Thank you for your patience

        
        </p>

        <div className="contact-buttons">

          <a
            href={facebookLink}
            target="_blank"
            rel="noreferrer"
            className="facebook-btn"
          >
            <FaFacebookF />
            Visit Facebook
          </a>

          <a
            href="tel:+201125000815"
            className="call-btn"
          >
            <FaPhoneAlt />
            Call Us
          </a>

        </div>

        <div className="phones">

            <span>
              <FaPhoneAlt />
              +971563068283
            </span>

            <span>
              <FaPhoneAlt />
              +201125000815
            </span>

            <span>
              <FaPhoneAlt />
              +201065865656
            </span>

            <div className="address">
              📍 Damanhour – Sky Mall – Unit B57
            </div>

        </div>

      </div>

      <footer>
        <GiSmokingVolcano />
        <span>
          Magma Media © 2026
        </span>
      </footer>

    </div>
  );
}

export default LaunchPage;